import { io } from 'socket.io-client';

const socket = io('https://apistaging.mybodysolutions.com', {
  transports: ['websocket'], // Optional: force websocket if needed
  reconnection: true,
  secure: true, // important if using HTTPS
  rejectUnauthorized: false, // optional, use only if self-signed certificate is an issue
});

export default socket;
